import { render, staticRenderFns } from "./ContactEditAddressEmails.vue?vue&type=template&id=0e82c186&scoped=true"
import script from "./ContactEditAddressEmails.vue?vue&type=script&lang=ts"
export * from "./ContactEditAddressEmails.vue?vue&type=script&lang=ts"
import style0 from "./ContactEditAddressEmails.vue?vue&type=style&index=0&id=0e82c186&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e82c186",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e82c186')) {
      api.createRecord('0e82c186', component.options)
    } else {
      api.reload('0e82c186', component.options)
    }
    module.hot.accept("./ContactEditAddressEmails.vue?vue&type=template&id=0e82c186&scoped=true", function () {
      api.rerender('0e82c186', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactEditAddressEmails.vue"
export default component.exports